import React from 'react';

export default function Page404() {
  return (
    <h1>Page Not Found</h1>
  )
}